// Fixed list of step topics used by "Build your walk". Keys are stored in the DB.
export const TOPICS = [
  { key: 'history', ru: 'История', en: 'History', ar: 'التاريخ' },
  { key: 'architecture', ru: 'Архитектура', en: 'Architecture', ar: 'العمارة' },
  { key: 'culture', ru: 'Традиции и культура', en: 'Culture & traditions', ar: 'الثقافة والتقاليد' },
  { key: 'markets', ru: 'Рынки и торговля', en: 'Markets & trade', ar: 'الأسواق والتجارة' },
  { key: 'food', ru: 'Еда', en: 'Food', ar: 'الطعام' },
  { key: 'creek', ru: 'Залив и абры', en: 'The Creek & abras', ar: 'الخور والعبرة' },
  { key: 'faith', ru: 'Религия и мечети', en: 'Faith & mosques', ar: 'الدين والمساجد' },
  { key: 'art', ru: 'Искусство', en: 'Art', ar: 'الفن' },
  { key: 'photo', ru: 'Места для фото', en: 'Photo spots', ar: 'أماكن للتصوير' },
];

export function topicLabel(key, lang) {
  const t = TOPICS.find(x => x.key === key);
  if (!t) return key;
  return t[lang] || t.en;
}
